$(document).ready(function() {
  // Facebook Custom Scroll Event Fire
  var executeWhenReachedPagePercentage = function(percentage, callback) {
    if (typeof percentage !== 'number') {
      console.error(
        'First parameter must be a number, got',
        typeof percentage,
        'instead',
      );
    }

    if (typeof callback !== 'function') {
      console.error(
        'Second parameter must be a function, got',
        typeof callback,
        'instead',
      );
    }

    function getDocumentLength() {
      var D = document;
      return Math.max(
          D.body.scrollHeight, D.documentElement.scrollHeight,
          D.body.offsetHeight, D.documentElement.offsetHeight,
          D.body.clientHeight, D.documentElement.clientHeight
      )
    }

    function getWindowLength() {
      return window.innerHeight || 
        (document.documentElement || document.body).clientHeight;
    }

    function getScrollableLength() {
      if (getDocumentLength() > getWindowLength()) {
        return getDocumentLength() - getWindowLength();
      } else {
        return 0;
      }
    }

    var scrollableLength = getScrollableLength();

    window.addEventListener("resize", function(){
      scrollableLength = getScrollableLength();
    }, false)

    function getCurrentScrolledLengthPosition() {
     return window.pageYOffset || 
       (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }

    function getPercentageScrolled() {
      var scrollTop = $(window).scrollTop();
      var docHeight = $(document).height();
      var winHeight = $(window).height();
      var scrollPercent = (scrollTop) / (docHeight - winHeight);
      var scrollPercentRounded = Math.round(scrollPercent*100);
      return scrollPercentRounded
    }

    var executeCallback = (function() {
      var wasExecuted = false;
      return function() {
        if (!wasExecuted && getPercentageScrolled() > percentage) {
          wasExecuted = true;
          callback();
        }
      };
    })();

    if (getDocumentLength() == 0 ||
      (getWindowLength()/getDocumentLength() * 100 >= percentage)) {
      callback();
    } else {
      window.addEventListener('scroll', executeCallback, false);
    }
  };

  var getTemplateName = function() {
    var tempName = null;
    if ($("body.template-index").length > 0) {
      tempName = "Home Page";
    } else if ($("body#welcome-offer").length > 0) {
      tempName = "Welcome Offer";
    }
    return tempName;
  }

  var fireCustomScrollEvent = function(percent, template) {
    fbq('trackCustom', 'Scrolled ' + template + ' ' + percent, {});
  }

  executeWhenReachedPagePercentage(20, function() {
    var templateName = getTemplateName();
    if (templateName) {
      fireCustomScrollEvent(20, templateName)
    }
  });

  executeWhenReachedPagePercentage(40, function() {
    var templateName = getTemplateName();
    if (templateName) {
      fireCustomScrollEvent(40, templateName)
    }
  });

  executeWhenReachedPagePercentage(60, function() {
    var templateName = getTemplateName();
    if (templateName) {
      fireCustomScrollEvent(60, templateName)
    }
  });

  executeWhenReachedPagePercentage(80, function() {
    var templateName = getTemplateName();
    if (templateName) {
      fireCustomScrollEvent(80, templateName)
    }
  });

  executeWhenReachedPagePercentage(95, function() {
    var templateName = getTemplateName();
    if (templateName) {
      fireCustomScrollEvent(100, templateName)
    }
  });

  // Review Engagement Custom FB Pixel Events
  var testimonialVideo = document.getElementById("testimonial-video-player");

  if (testimonialVideo) {
    testimonialVideo.onplay = function() {
      fbq('trackCustom', 'Review Engagement', {location: 'Testimonial Video'});
    }; 
  }

  $(".template-product .jdgm-preview-badge").click(function() {
    fbq('trackCustom', 'Review Engagement', {location: 'Product Top Stars'});
  })

  $(".see-all-review-btn").click(function() {
    fbq('trackCustom', 'Review Engagement', {location: 'See All Reviews Button'});
  })

  if ($(".template-product, #welcome-offer").length) {
    $(document).on("click", "#judgeme_product_reviews .jm-load-more-pagination .jm-button", function() {
      fbq('trackCustom', 'Review Engagement', {location: 'Loaded More Reviews'});
    })
  }

})


